import React, { Suspense, useEffect, useRef } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import MainLayout from '@app/components/layouts/main/MainLayout/MainLayout';
import { Loading } from '@app/components/common/Loading';
import { ProtectedOutlet } from './guards/ProtectedOutlet';
import { renderRouteDefinitions } from './routeDefinition';
import { baseRoutes } from './routes/baseRoutes';
import { menuProtectedRoutes } from './routes/menuProtectedRoutes';
import { mjeGuideFlowRoutes } from './routes/mjeRoutes';
import { errorRoutes } from './routes/errorRoutes';

export const AppRouter: React.FC = () => {
  const { keycloak, initialized } = useKeycloak();
  const loginStartedRef = useRef(false);

  useEffect(() => {
    if (!initialized || keycloak.authenticated || loginStartedRef.current) {
      return;
    }

    loginStartedRef.current = true;
    keycloak.login({ redirectUri: window.location.href });
  }, [initialized, keycloak]);

  if (!initialized) return <Loading />;

  if (!keycloak.authenticated) {
    return <Loading />;
  }

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route element={<MainLayout />}>
            {renderRouteDefinitions(baseRoutes)}

            <Route element={<ProtectedOutlet />}>
              {renderRouteDefinitions(menuProtectedRoutes)}
            </Route>

            <Route
              element={<ProtectedOutlet requiredPath="/mje/consulta-guias" />}
            >
              {renderRouteDefinitions(mjeGuideFlowRoutes)}
            </Route>

            {renderRouteDefinitions(errorRoutes)}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
